module.exports = __webpack_public_path__ + "img/密码器11.f26d7c81.jpg";